module.exports = __webpack_public_path__ + "c6caa71674d629cecbc36a08c3bed2a3.MP3";